import state from './moduleAuthState';
import mutations from './moduleAuthMutations';
import actions from './moduleAuthActions';
import getters from './moduleAuthGetters';

const store = {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};

export default store;
